import { Filenames } from '../../../cimsPage/instances/importsExports'
import { Simple } from '../../common'

const object = 'Filename'
const page = Filenames

export const ViewFilename = Simple({
  id: '02F244EC-70B5-4C57-BBA1-BA44A36AB6B0',
  action: 'View',
  object,
  page,
})

export const EditFilename = Simple({
  id: '8FE11B05-5D12-4468-AAFE-0B1A011CC8A5',
  action: 'Edit',
  object,
  page,
})

export type FilenamePermission = typeof ViewFilename | typeof EditFilename
